"use client";

// import Lightbox from "@/components/shared/ligthbox";
import Marquee from "@/components/ui/marquee";
import { PersonalityProps } from "@/services/home/types";
import Image from "next/image";
import React from "react";

const CelebCard = ({
  img,
  name,
  award,
  onClick,
}: {
  img: string;
  name: string;
  award: string;
  onClick?: () => void;
}) => {
  return (
    <figure
      onClick={onClick}
      className="relative h-[160px] w-[110px] overflow-hidden !rounded-[1.67vw] sm:h-[220px] sm:w-[180px] md:h-[260px] md:w-[220px] lg:h-[320px] lg:w-[280px] 2xl:w-[240px] 3xl:h-[343px] 3xl:w-[312px]"
      // style={{
      //   background:
      //     "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%)",
      // }}
    >
      {/* <div className="pointer-events-none absolute inset-x-0 -bottom-4 z-30 h-1/3 bg-gradient-to-t from-white dark:from-background"></div> */}
      <Image
        loading="lazy"
        src={img}
        fill
        alt={name}
        quality={85}
        sizes="(max-width: 640px) 110px, (max-width: 768px) 180px, (max-width: 1024px) 220px, 280px"
        style={{ objectFit: "cover" }}
      />
      <div className="absolute inset-0 z-50 flex flex-col justify-end p-2">
        <h5 className="text-xs text-secondary sm:text-base ltr:font-playfair">{name}</h5>
        <span className="text-[10px] sm:text-base ltr:font-opensans">{award}</span>
      </div>
    </figure>
  );
};

export function Winners({ data }: { data: PersonalityProps[] }) {
  const row1 = data.slice(0, 6);
  const row2 = data.slice(6, 12);
  const row3 = data.slice(12);

  // const [index, setIndex] = React.useState(-1);

  return (
    <div className="relative grid h-[570px] grid-cols-3 gap-2 sm:gap-4 md:h-[670px] lg:h-[900px] 3xl:h-[1000px]">
      <Marquee pauseOnHover vertical className="p-0 [--duration:20s]">
        {row1.map((celeb) => (
          <CelebCard
            // onClick={() => setIndex(idx)}
            key={celeb.id}
            award={celeb.description ?? ""}
            name={celeb.name ?? ""}
            img={celeb.image_link ?? ""}
          />
        ))}
      </Marquee>
      <Marquee reverse pauseOnHover vertical className="p-0 [--duration:20s]">
        {row2.map((celeb) => (
          <CelebCard
            // onClick={() => setIndex(idx + 4)}
            key={celeb.id}
            award={celeb.description ?? ""}
            name={celeb.name ?? ""}
            img={celeb.image_link ?? ""}
          />
        ))}
      </Marquee>
      <Marquee pauseOnHover vertical className="p-0 [--duration:20s]">
        {row3.map((celeb) => (
          <CelebCard
            // onClick={() => setIndex(idx + 8)}
            key={celeb.id}
            award={celeb.description ?? ""}
            name={celeb.name ?? ""}
            img={celeb.image_link ?? ""}
          />
        ))}
      </Marquee>
      <div className="top-fade-purple pointer-events-none absolute inset-x-0 -top-4 z-20 hidden h-1/4 sm:h-1/3 2xl:block"></div>
      <div className="top-fade-purple-mobile pointer-events-none absolute inset-x-0 -top-4 z-20 h-1/4 sm:h-1/3 2xl:hidden"></div>

      <div className="bottom-fade-purple pointer-events-none absolute inset-x-0 -bottom-4 h-1/3"></div>
    </div>
  );
}
